import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';

import Form from '../Form';
import Strings from '../../Strings';

export default function SimpleModal(
  { name, className, title, onCancel, onSubmit, isSubmitDisabled, content, customButtons, emptyFieldsCount, saveButtonTooltip, onNextButtonHover, submitText }
) {
  const [nextButtonHovered, setNextButtonHovered] = React.useState(false);

  const handleNextButtonHover = value => {
    if (onNextButtonHover) {
      onNextButtonHover(value);
    }
    setNextButtonHovered(value);
  };

  return (
    <div className="dialog-overlay">
      <div className={`wizard ${name} ${className || ''}`}>
        <header className="wizardHeader" data-testid="wizard-header">
          <div className="horizontal-flex center header-content">
            <div />
            {title}
            <div />
          </div>
          <div className="requiredFieldsError">
            {nextButtonHovered && emptyFieldsCount > 0
              ? `${emptyFieldsCount} *${Strings.fieldsRequired}`
              : '\xa0'}
          </div>
        </header>
        <div className="wizardContent">
          <Form onCancel={onCancel} id={name}>
            <OverlayScrollbarsComponent
              defer
              options={{ scrollbars: { autoHide: 'leave', autoHideDelay: '100' } }}
              className="scrollbar-right-margin"
            >
              <div className="content-block">
                {content}
              </div>
            </OverlayScrollbarsComponent>
            {customButtons || (
              <div className="buttons" key="button-bar">
                <div className="bottom-button-container">
                  <button className="brand-white-gray" key="cancel" type="cancel" onClick={onCancel}>
                    {Strings.cancel}
                  </button>
                </div>
                <div
                  className="bottom-button-container"
                  onMouseEnter={() => handleNextButtonHover(true)}
                  onMouseLeave={() => handleNextButtonHover(false)}
                  data-tooltip-html={ReactDOMServer.renderToStaticMarkup(saveButtonTooltip)}
                  data-tooltip-id={saveButtonTooltip ? 'tooltip' : undefined}
                >
                  <button
                    className="brand-blue"
                    key="submit"
                    type="button"
                    onClick={onSubmit}
                    disabled={isSubmitDisabled}
                    data-testid="submit-button"
                  >
                    {submitText || Strings.save}
                  </button>
                </div>
              </div>
            )}
          </Form>
        </div>
      </div>
    </div>
  );
}